module.exports = __webpack_public_path__ + "img/companyProfile.278cd0ad.png";